// Calls to the municipality endpoints of the service. The PocketBase token proves who is asking.
export async function muniFetch(pb, path, options = {}) {
  const res = await fetch(`${process.env.VUE_APP_SERVER_URL}${path}`, {
    ...options,
    headers: { ...(options.headers || {}), Authorization: `Bearer ${pb.authStore.token}` },
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res;
}

export const STATUSES = ['reported', 'in_review', 'planned', 'fixed'];
